<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconExport_16"
    viewBox="0 0 16 17"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m13.125 6.634-4.54 4.54a.602.602 0 0 1-.852 0l-4.54-4.54a.602.602 0 0 1 .693-.965l3.347 1.664V.926a.926.926 0 0 1 1.852 0v6.407l3.347-1.664a.601.601 0 0 1 .693.965ZM1.7 11.517a.7.7 0 0 1 .7.7v2.1h11.2v-2.1a.7.7 0 1 1 1.4 0v2.8a.7.7 0 0 1-.428.645l-.015.006a.698.698 0 0 1-.257.049H1.7a.7.7 0 0 1-.7-.7V12.217a.7.7 0 0 1 .7-.7Z"
    />
</svg>
